import { getAllowExternalLinks } from '../storage/privacySettingsStore.ts'
import { t } from '../i18n/index.ts'

const URL_RE = /https?:\/\/[^\s<>"']+/gi

export function extractUrls(text: string): string[] {
  return [...text.matchAll(URL_RE)].map((m) => m[0])
}

export function canOpenExternalUrl(url: string): boolean {
  if (!getAllowExternalLinks()) return false
  try {
    const u = new URL(url)
    return u.protocol === 'http:' || u.protocol === 'https:'
  } catch {
    return false
  }
}

export function openExternalUrl(url: string): boolean {
  if (!canOpenExternalUrl(url)) {
    window.alert(t('link_blocked'))
    return false
  }
  window.open(url, '_blank', 'noopener,noreferrer')
  return true
}

/** HTML sicuro: link cliccabili o testo plain se bloccati. */
export function renderMessageHtml(text: string, escapeHtml: (s: string) => string): string {
  if (!getAllowExternalLinks()) {
    return escapeHtml(text)
  }
  const parts = text.split(URL_RE)
  const urls = text.match(URL_RE) ?? []
  let out = ''
  for (let i = 0; i < parts.length; i++) {
    out += escapeHtml(parts[i] ?? '')
    if (i < urls.length) {
      const url = urls[i]!
      out += `<a class="msg-link" href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer">${escapeHtml(url)}</a>`
    }
  }
  return out
}
